import { render, staticRenderFns } from "./CNCKanban.vue?vue&type=template&id=3da02abf&"
import script from "./CNCKanban.vue?vue&type=script&lang=js&"
export * from "./CNCKanban.vue?vue&type=script&lang=js&"
import style0 from "./CNCKanban.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports